module.exports = __webpack_public_path__ + "img/Value1_s.21a4c7b5.png";